import _ from 'lodash'
import axios from 'axios'
import Vue from 'vue'

export const state = {
  all: [],
  availabilities: [],
}

export const getters = {
  getRoomIndex: (state) => (id) =>
    state.all.findIndex((room) => room.id === id),
  getRoomById: (state, getters) => (id) => state.all[getters.getRoomIndex(id)],
  getRoomDetailByCart: (state, getters) => (roomCart) => {
    const room = getters.getRoomById(roomCart.id)
    const ratePlan = room.ratePlans.find(
      (ratePlan) => ratePlan.id === roomCart.ratePlanId
    )

    return { room, ratePlan }
  },
  getAvailabilityIndex: (state) => (id) =>
    state.availabilities.findIndex((room) => room.id === id),
  getAvailability: (state, getters) => (id) => {
    const index = getters.getAvailabilityIndex(id)

    return state.availabilities[index].availability
  },
  getRoomByCart: (state) => (cart) => _.find(state.all, { id: cart.id }),
  getRatePlanByCart: (state, getters) => (cart) => {
    const { ratePlans } = getters.getRoomByCart(cart)

    return _.find(ratePlans, { id: cart.ratePlanId })
  },
  getRoomCancellationByCart: (state, getters) => (cart) => {
    const ratePlan = getters.getRatePlanByCart(cart)

    return ratePlan.promotion
      ? ratePlan.promotion.cancellation
      : ratePlan.cancellationId
  },
  lowestRoomRate: (state) => {
    if (state.all.length < 1) {
      return { gross: 0, net: 0 }
    }

    const { gross, net } = state.all[0].ratePlans[0].rate.promotion

    return { gross, net }
  },
}

export const mutations = {
  SET_ALL(state, newRooms) {
    state.all = newRooms
    state.availabilities = newRooms.map(({ id, availability }) => ({
      id,
      availability,
    }))
  },
  SET_ROOM_AVAILABLE(state, { id, qty }) {
    const rec = state.all.find((rm) => rm.id === id)
    if (rec) {
      const index = _.findIndex(state.all, { id })
      const available = rec.available + qty
      const updatedRec = Object.assign({}, rec, { available })
      Vue.set(state.all, index, updatedRec)
    }
  },
  SET_ROOM_AVAILABILITY(state, { index, payload }) {
    Vue.set(state.availabilities, index, payload)
  },
}

export const actions = {
  fetch({ commit, rootGetters }, { property }) {
    const searchParameters = rootGetters['cart/searchParams']

    return axios
      .post('/api/v2/get_rooms', { property, ...searchParameters })
      .then((response) => {
        const { data } = response

        commit('SET_ALL', data)

        return data
      })
  },
  updateRoomCart: {
    root: true, // triggered by global action: roomCart
    handler({ state, getters, commit, rootGetters }, { room }) {
      const index = getters.getAvailabilityIndex(room.id)
      const rec = state.availabilities[index]
      const totalRoomInCart = rootGetters['cart/rooms/getTotalRoom'](room)
      const availability = room.availability - totalRoomInCart
      const payload = Object.assign({}, rec, { availability })

      commit('SET_ROOM_AVAILABILITY', { index, payload })
    },
  },
}
